import {useParams} from 'react-router-dom';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import ShareTitleHeader from '../../../../components/mazraeKit/headers/shareTitleHeader';
import NoData from '../../../../components/noData';
import useGetBrandSaleAgent from '../../../../services/hookService/getBrandSaleAgent/useGetBrandSaleAgent';
import SaleAgentCard from './SaleAgentCard';
import SaleAgentCardSkeleton from './SaleAgentCardSkeleton';

const SaleAgentsPage = () => {
  const {brandId} = useParams();

  const {data, isLoading} = useGetBrandSaleAgent(+brandId!);

  return (
    <div className="flex flex-col w-full h-full">
      <ShareTitleHeader title="عاملین فروش" hideShareIcon={true} />

      <div className="flex-1 p-4 pb-20 space-y-4 overflow-y-auto">
        {isLoading ? (
          Array.from({length: 5}).map((_, index) => (
            <div className="mb-3">
              <SaleAgentCardSkeleton key={index} />
            </div>
          ))
        ) : data?.length === 0 ? (
          <div className="flex items-center justify-center h-full -mt-8">
            <NoData text="هیچ عامل فروشی برای این برند ثبت نشده است" />
          </div>
        ) : (
          data?.map(agent => <SaleAgentCard key={agent.guid} data={agent} />)
        )}
      </div>

      <div className="fixed bottom-0 left-0 right-0">
        <MainFooter />
      </div>
    </div>
  );
};

export default SaleAgentsPage;
